import React from "react";
import { TRADITION_LAYERS } from "./config";

export default function TimelineLegend({ periodMap, state, visiblePeriods }) {
  const selectedLayers = TRADITION_LAYERS.filter(({ slug }) => state[slug]);
  if (!state.periods && !state.events && selectedLayers.length === 0) return null;

  return (
    <div className="history-chart__legend" aria-label="Timeline key" data-testid="history-period-legend">
      {state.periods && visiblePeriods.map((period) => (
        <span key={period.slug}>
          <i style={{ backgroundColor: periodMap.get(period.slug).color }} aria-hidden="true" />
          {period.name}
        </span>
      ))}
      {state.events && (
        <span><i className="history-chart__legend-event" aria-hidden="true" />Other historical event</span>
      )}
      {selectedLayers.map((layer) => (
        <span key={layer.slug}>
          <i className={`history-chart__legend-${layer.slug}`} aria-hidden="true" />
          {layer.legend}
        </span>
      ))}
    </div>
  );
}
